/*
  Automatic bundle discount codes.

  Watches the cart (theme 'cart:updated' / 'ajaxProduct:added' events) and:
  - when ALL products of a bundle are in the cart, applies that bundle's
    discount code (BUNDLE-<HANDLE>) to the cart, so checkout shows the
    percentage off automatically;
  - when the set breaks (an item is removed), removes the code again;
  - preserves any discount codes the customer entered themselves.

  Codes are attached/detached via POST /cart/update.js with the `discount`
  parameter (comma-separated codes; '' clears) — the supported Cart AJAX way.

  Bundle definitions come from the JSON rendered by snippets/bundle-data.liquid
  (shop metafield custom.bundle_config, maintained by Shopify Flow).
*/
(function() {
  'use strict';

  var dataEl = document.querySelector('[data-bundle-codes-data]');
  if (!dataEl) { return; }

  var bundles;
  try {
    var config = JSON.parse(dataEl.textContent);
    bundles = (config && config.bundles) || [];
  } catch (e) {
    return;
  }

  // products may arrive as an array of GIDs, an array of numbers, or a
  // JSON-encoded string (Flow templating) — normalize to numeric IDs.
  bundles = bundles
    .map(function(b) {
      var raw = b.products;
      if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); } catch (e) { raw = []; }
      }
      if (!Array.isArray(raw)) { raw = []; }
      var ids = raw
        .map(function(p) { return parseInt(String(p).split('/').pop(), 10); })
        .filter(function(n) { return !isNaN(n); });
      return { code: String(b.code || '').toUpperCase(), products: ids };
    })
    .filter(function(b) { return b.code && b.products.length > 1; });

  if (!bundles.length) { return; }

  var ourCodes = {};
  bundles.forEach(function(b) { ourCodes[b.code] = true; });

  var STORAGE_KEY = 'bundleCode:applied';
  var evaluating = false;
  var queued = false;
  var lastWrite = { value: null, at: 0 };

  function getApplied() {
    try { return sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function setApplied(code) {
    try {
      if (code) { sessionStorage.setItem(STORAGE_KEY, code); }
      else { sessionStorage.removeItem(STORAGE_KEY); }
    } catch (e) { /* private mode */ }
  }

  // Codes currently attached to the cart, if the cart JSON exposes them.
  // Returns null when unknown (older cart payloads without discount info).
  function cartCodes(cart) {
    var arr = cart && (cart.discount_codes || cart.discountCodes);
    if (!Array.isArray(arr)) { return null; }
    return arr
      .map(function(d) { return String(d && d.code !== undefined ? d.code : d).toUpperCase(); })
      .filter(Boolean);
  }

  function writeCodes(codes) {
    var value = codes.join(',');
    // Loop guard: don't re-issue the same write within 5s (e.g. if the cart
    // response doesn't reflect a code Shopify rejected).
    var now = Date.now();
    if (lastWrite.value === value && now - lastWrite.at < 5000) {
      return Promise.resolve(null);
    }
    lastWrite = { value: value, at: now };

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: value })
    }).then(function(res) { return res.ok ? res.json() : null; });
  }

  function evaluate(cart) {
    if (evaluating) { queued = true; return; }
    evaluating = true;

    var finish = function() {
      evaluating = false;
      if (queued) { queued = false; evaluate(); }
    };

    var cartPromise = cart && cart.items
      ? Promise.resolve(cart)
      : fetch('/cart.js?_bc=' + Date.now(), { credentials: 'same-origin' }).then(function(r) { return r.json(); });

    cartPromise.then(function(cartData) {
      var inCart = {};
      (cartData.items || []).forEach(function(item) { inCart[item.product_id] = true; });

      var complete = bundles.filter(function(b) {
        return b.products.every(function(pid) { return inCart[pid]; });
      });
      // If several bundles are complete, prefer the largest.
      complete.sort(function(a, b) { return b.products.length - a.products.length; });
      var desired = complete.length ? complete[0].code : null;

      var known = cartCodes(cartData);
      var foreign = (known || []).filter(function(c) { return !ourCodes[c]; });
      var appliedOurs = known
        ? known.filter(function(c) { return ourCodes[c]; })
        : (getApplied() ? [getApplied()] : []);

      var alreadyRight = desired
        ? (appliedOurs.length === 1 && appliedOurs[0] === desired)
        : appliedOurs.length === 0;

      if (alreadyRight) { finish(); return; }

      var newCodes = desired ? foreign.concat([desired]) : foreign;

      writeCodes(newCodes)
        .then(function(updatedCart) {
          setApplied(desired);
          // Legacy pre-applied-code cookie cleanup (belt and braces).
          if (!desired) { document.cookie = 'discount_code=; Max-Age=0; path=/'; }
          if (updatedCart && updatedCart.items) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: updatedCart },
              bubbles: true
            }));
          }
        })
        .then(finish, finish);
    }).catch(finish);
  }

  document.addEventListener('cart:updated', function(evt) {
    evaluate(evt.detail && evt.detail.cart);
  });
  document.addEventListener('ajaxProduct:added', function() {
    evaluate();
  });
  // The drawer's manual code input applies via /discount/ without firing
  // cart:updated — re-evaluate shortly after so bundle codes typed in without
  // a complete set get stripped again.
  document.addEventListener('click', function(evt) {
    if (evt.target.closest('.c-discount-apply')) {
      setTimeout(function() { evaluate(); }, 1500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { evaluate(); });
  } else {
    evaluate();
  }
})();
